import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, FieldArray } from 'redux-form';
import cn from 'classname';
import noop from 'lodash/noop';

import renderViewsState from '../shared/render-views-state';

import Search from '../shared/search';
import { showMoreRowsDiv } from '../shared/table-helpers';
import Affiliate from './affiliate';
import Offers from './offers';

lessRequire('modules/affiliates/main.less');

const isEverad = process.env.CPA_ENV === 'everad';

const Main = renderViewsState(props => {
	return (
		<div className="affiliates-wrap container">
			<div className="container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{props.intl('Вебмастера')}</h2>
					<Search
						{...props}
						form="affiliatesSearchForm"
						action={props.applySearch}
						initialValues={props.childAffiliatesFormData.searchInitialValue}
						destroyOnUnmount={false}
					/>
					<a
						href={`tickets/request/new-affiliate/`}
						className="button yellow-btn add-affiliate-button font-proxima-nova-semibold"
						target="_blank">
						{props.intl('Добавить вебмастера')}
					</a>
				</div>
				<div className="affiliates-wrap__table">
					<Form {...props} {...props.childAffiliatesFormData} />
				</div>
			</div>
		</div>
	);
});

const Form = reduxForm({
	form: 'childAffiliatesForm',
	enableReinitialize: true,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false
})(props => (
	<div className="affiliates-container">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.submitForm(data))}>
			<FieldArray name="child_affiliates" {...props} component={RenderAffiliatesArray} />
			{props.data && props.data.length < props.affiliatesTotal
				? showMoreRowsDiv(props.showMore, 'AffiliatesForm', props.intl)
				: null}
			<div className="ui-form__element affiliates-form__buttons-wrap">
				<button className="button yellow-btn affiliates-submit font-proxima-nova-semibold">
					{props.intl('Сохранить')}
				</button>
			</div>
		</form>
	</div>
));

const RenderAffiliatesArray = props => (
	<div className="entity-wrap">
		<table className="entity-wrap__table">
			<thead className="entity-wrap__table-head font-proxima-nova-semibold">
				<tr>
					<th className="affiliate">{props.intl('Вебмастера')}</th>
					<th className="offers-count">{props.intl('Офферы')}</th>
					<th className="offers-count">{props.intl('Доход') + ', $'}</th>
					{isEverad && <th className="offers-count">{props.intl('Доход') + ', €'}</th>}
				</tr>
			</thead>
			{props.fields.length > 0 ? (
				<tbody className="entity-wrap__table-body">
					{props.fields.map((parentName, index, fields) => {
						const res = [];
						const shouldShowOffers = props.listOfActiveAffiliatesPanIndex.indexOf(index) > -1;
						const panHasAddedOffer = props.listOfAddedOffersPanIndex.indexOf(index) > -1;

						const onToggleOffersPan = props.fields.get(index)
							? shouldShowOffers
								? props.hideAffiliateOffers
								: handleShowOffers(props.fields.get(index), props.fetchAffiliateOffers)
							: noop;

						const addOfferOptions = props.masterOffers
							.filter(
								o => props.fields.get(index)['offer_ids'] && props.fields.get(index)['offer_ids'].indexOf(o.id) === -1
							)
							.map(o => ({ label: o.title, value: o.id }));

						// affiliates row
						res.push(
							<Affiliate
								key={index}
								className={cn({
									'is-show-offers': shouldShowOffers,
									'modify-cursor-pointer': true
								})}
								type="affiliate"
								parentName={parentName}
								index={index}
								intl={props.intl}
								placeholder={props.intl('Выбрать вебмастера')}
								fields={props.fields}
								entityOptions={props.selectOptions['affiliates']}
								onToggleOffersPan={onToggleOffersPan}
								onFetchOffers={props.fetchAffiliateOffers}
								offersAmount={
									addOfferOptions.length && props.listOfAddedOffersPanIndex.indexOf(index) === -1
										? (props.fields.get(index)['offers'].length || 0) + 1
										: props.fields.get(index)['offers'].length || 0
								}
								shouldShowOffers={shouldShowOffers}
								shownTargetPixelHeightsMap={props.shownTargetPixelHeightsMap}
								copyTerms={props.copyTerms}
							/>,
							<tr key={`affiliates-padding-${index}`} className="padding-tr" />
						);

						// offers row
						shouldShowOffers &&
							res.push(
								<FieldArray
									name={`${parentName}.offers`}
									intl={props.intl}
									payoutCurrencies={props.payoutCurrencies}
									parentIndex={index}
									component={Offers}
									entityOptions={props.selectOptions['offers']}
									listOfActiveOffersPanIndex={props.listOfActiveOffersPanIndex}
									listOfAddedOffersPanIndex={props.listOfAddedOffersPanIndex}
									showOfferTargets={props.showOfferTargets}
									hideOfferTargets={props.hideOfferTargets}
									updateShownTargetsPixelHeights={props.updateShownTargetsPixelHeights}
									addOfferOptions={addOfferOptions}
									addOffer={props.addOffer}
									affiliate={props.fields.get(index)['affiliate']}
									clickAddOffer={props.clickAddOffer}
									panHasAddedOffer={panHasAddedOffer}
									copyTerms={props.copyTerms}
									nullifyBoostOnSubmit={props.nullifyBoostOnSubmit}
									nullifiedBoosts={props.nullifiedBoosts}
								/>
							);

						return res;
					})}
				</tbody>
			) : (
				<span style={{ margin: '10px 0', display: 'block' }}>{props.intl('По Вашему запросу нет данных')}...</span>
			)}
		</table>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitForm: PropTypes.func,
	intl: PropTypes.func
};

RenderAffiliatesArray.propTypes = {
	fields: PropTypes.object,
	intl: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	offersLookups: PropTypes.func,
	hideOfferTargets: PropTypes.func,
	showOfferTargets: PropTypes.func,
	toggleAddAffiliateSelect: PropTypes.func,
	updateShownTargetsPixelHeights: PropTypes.func,
	clickAddOffer: PropTypes.func,
	listOfAddedOffersPanIndex: PropTypes.array,
	copyTerms: PropTypes.func,
	nullifyBoostOnSubmit: PropTypes.func,
	nullifiedBoosts: PropTypes.array
};

const handleShowOffers = (entity, onFetchOffers) => index => {
	onFetchOffers(index, entity.affiliate);
};

export default connect(
	state => ({
		data: selectors.getData(state),
		intl: selectors.getIntl(state),
		payoutCurrencies: selectors.getPayoutCurrencies(state),
		childAffiliatesFormData: selectors.getFormData(state),
		affiliatesTotal: selectors.getAffiliatesTotal(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/affiliates/main.js